export const FETCH_CODES = 'codes';
export const UPDATE_ACTIVE_SORT_FIELD_CODES = 'updateActiveSortFieldCodes';
export const UPDATE_SEARCH_CODES = 'updateSearchCodes';
export const CLEAR_SEARCH_CODES = 'clearSearchCodes';
export const DELETE_CODE = 'deleteCode';
export const ADD_CODE = 'createCode';
